import { createFileRoute } from '@tanstack/react-router';
import { ScopedUserForm } from '../../components/scoped/ScopedUserForm';
import { TENANT_DESCRIPTOR } from '../../components/scoped/scopeDescriptors';

export const Route = createFileRoute('/_authenticated/_layout/tenant/users/new')({
    component: () => (
        <div className="space-y-4">
            <h1 className="text-2xl font-semibold">Crear user</h1>
            <ScopedUserForm descriptor={TENANT_DESCRIPTOR} />
        </div>
    ),
});
